<script lang="ts" setup>
import { computed } from "vue";
import { useSnackbarStore } from "@/store/snackbar.store";
import type { SnackbarTarget } from "@/store/snackbar.store";

defineOptions({ name: "OmniSnackbar" });

const props = withDefaults(
  defineProps<{
    target?: SnackbarTarget;
  }>(),
  {
    target: "main",
  },
);

const snackbarStore = useSnackbarStore();

const snackbar = computed(() => snackbarStore.snackbar);

const show = computed({
  get: () => Boolean(snackbar.value.show) && (snackbar.value.target ?? "main") === props.target,
  set: (value: boolean) => {
    if (!value) {
      snackbarStore.closeSnackBar();
    }
  },
});
</script>

<template>
  <v-snackbar
    v-model="show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    location="bottom right"
    multi-line
    variant="flat"
  >
    {{ snackbar.text }}
    <template #actions>
      <v-icon class="cursor-pointer" @click="snackbarStore.closeSnackBar()">mdi-close</v-icon>
    </template>
  </v-snackbar>
</template>

<style lang="scss" scoped>
:deep(.v-snackbar__actions) {
  align-self: start;
  margin-top: 8px;
}
</style>
